import * as React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useGlynt from '../../hooks/useGlynt';
import { AppContext } from '../../../App';
import { ITrainingSet } from '../../../types/my-types';
import { saveAs } from 'file-saver';
import { useQuery } from '@tanstack/react-query';
import IconButtonWhiteBg from '../../common/IconButtonWhiteBg';
import DownloadIcon from '@mui/icons-material/Download';

export interface IDownloadDataReportProps {
  disabled: boolean;
  trainingSet: ITrainingSet;
}

const DownloadDataReport: React.FC<IDownloadDataReportProps> = ({ disabled, trainingSet }) => {
  const { isStaff } = React.useContext(AppContext);
  const [open, setOpen] = React.useState(false);
  const [submittedMutation, setSubmittedMutation] = React.useState(false);
  const [reportType, setReportType] = React.useState('stats');
  const glynt = useGlynt();
  const { refetch } = useQuery({
    queryKey: ['fieldDistribution'],

    queryFn: async () =>
      (await glynt).trainingSet.fieldDistribution(trainingSet.id, {
        advanced: true,
        format: 'csv',
        report_type: reportType,
      }),

    enabled: false
  });
  return (
    <div id="training-set-report" style={{ display: 'inline' }}>
      <IconButtonWhiteBg
        disabled={disabled}
        onClick={() => setOpen(true)}
        id="icon-training-set-report-download-data"
        cypressId="icon-training-set-report-download-data"
        tooltip="Download Data Report"
      >
        <DownloadIcon style={{ fontSize: '14px', color: 'black' }} />
      </IconButtonWhiteBg>

      <Dialog
        id="training-set-report-dialog"
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Download Data Report</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <DialogContentText>Report Type</DialogContentText>
            <Select
              id="training-set-report-type"
              value={reportType}
              data-cy="select-training-set-report-type"
              onChange={(e) => {
                const value = e.target.value;
                if (typeof value === 'string') {
                  setReportType(value);
                }
              }}
              inputProps={{
                name: 'report-type',
                id: 'report-type',
              }}
            >
              <MenuItem value={'stats'}>STATS</MenuItem>
              {isStaff ? <MenuItem value={'long'}>LONG</MenuItem> : null}
              <MenuItem value={'wide'}>WIDE</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button id="training-set-report-cancel" onClick={() => setOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            id="training-set-report-download"
            data-cy="btn-training-set-report-download"
            disabled={submittedMutation}
            onClick={async () => {
              setSubmittedMutation(true);
              refetch()
                .then((data) => {
                  // console.log(data);
                  // @ts-ignore
                  const blob = new Blob([data.data], {
                    type: 'application/csv;charset=utf-8',
                  });
                  saveAs(blob, `${trainingSet.label}-data-${reportType}-report.csv`);
                  setOpen(false);
                  setSubmittedMutation(false);
                })
                .catch((error) => {
                  console.error(error);
                  setSubmittedMutation(false);
                });
            }}
            color="secondary"
          >
            {submittedMutation ? <CircularProgress size={16} /> : 'Download'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DownloadDataReport;
